module.exports = __webpack_public_path__ + "img/1.d5db2fe.png";